import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatTextNumber, roundNumber } from "../../../../utils/helpers";
import { Ellipse } from "../../../assets/icons.constants";
import "./checkout-discounts.scss";
export default function CheckOutDiscounts(props) {
  const discounts = useSelector((state) => state?.session?.orderInfo.cartValidated?.promotionsSummary ?? []);
  const customerDiscountAmount = useSelector(
    (state) => state?.session?.orderInfo.cartValidated?.customerDiscountAmount ?? 0,
  );
  const customerMemberShipLevel = useSelector(
    (state) => state?.session?.orderInfo.cartValidated?.customerMemberShipLevel ?? 0,
  );
  const customerMemberShipDiscount = useSelector(
    (state) => state?.session?.orderInfo.cartValidated?.customerMemberShipDiscount ?? 0,
  );
  const calculateCustomerLoyaltyPoint = useSelector(
    (state) => state?.session?.orderInfo?.cartValidated?.calculateCustomerLoyaltyPoint,
  );

  const cartItems = useSelector((state) => state?.session?.orderInfo?.cartValidated?.cartItems) ?? [];

  const { t } = useTranslation();
  const pageData = {
    promotion: t("checkOutPage.promotion", "Promotion"),
    customerMemberShip: t("checkOutPage.customerMemberShip", "Hạng thành viên"),
    points: t("checkOutPage.availablePoint.Points", "Điểm"),
    use: t("checkOutPage.availablePoint.use", "Dùng"),
    point: t("checkOutPage.availablePoint.point", "điểm"),
    flashSale: t("checkOutPage.flashSale", "Flash sale"),
    combo: t("checkOutPage.combo", "Combo"),
  };

  const renderPromotions = discounts?.map((discount) => {
    if (discount?.isPercentDiscount)
      return (
        <>
          <div className="discountItem">
            <div className="discountName">
              <Ellipse className="discountItem-ellipse" />
              {discount?.promotionName} ({discount?.percentNumber} %)
            </div>
            <div className="discountAmount">-{formatTextNumber(roundNumber(discount?.totalDiscountAmount, 2))} đ</div>
          </div>
        </>
      );
    return (
      <>
        <div className="discountItem">
          <div className="discountName">{discount?.promotionName}</div>
          <div className="discountAmount">-{formatTextNumber(roundNumber(discount?.promotionValue, 2))} đ</div>
        </div>
      </>
    );
  });

  return (
    <>
      <div className="checkout-discounts-theme2">
        {customerDiscountAmount > 0 && (
          <div className="customerDiscount">
            <div className="promotionTitle">{pageData.customerMemberShip}</div>
            <ul>
              <li style={{ marginLeft: "32px", fontSize: "20px" }}>
                <div className="detail">
                  <div className="discountName">
                    {customerMemberShipLevel + " (" + customerMemberShipDiscount + "%)"}
                  </div>
                  <div className="discountAmount">-{formatTextNumber(roundNumber(customerDiscountAmount, 2))} đ</div>
                </div>
              </li>
            </ul>
          </div>
        )}

        {discounts?.length > 0 && <div className="promotionTitle">{pageData.promotion}</div>}
        <div className="discountList">{renderPromotions}</div>
        {!props.isPos && (
          <>
            <div className="promotionTitle">{pageData.points}</div>
            <div className="discountList">
              {/* Loyalty point */}
              {calculateCustomerLoyaltyPoint && (
                <div className="discountItem">
                  <div className="name">
                    <Ellipse className="discountItem-ellipse" />
                    {pageData.use}{" "}
                    <span className="discountItem-loyaltyPoint">{calculateCustomerLoyaltyPoint?.pointUsed}</span>{" "}
                    {pageData.point}
                  </div>
                  <div className="amount">
                    -{formatTextNumber(calculateCustomerLoyaltyPoint?.pricePointUsed ?? 0)} đ
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}
